export default __webpack_public_path__ + "static/media/logo.866241ce.webp";